import * as React from "react";
import { useFeatureToggles } from "@grandvisionhq/state";
import { mapStepToRoute, steps } from "../../../../../v3/components/Navigation/steps.js";
const useDisableSteps = (active, queryParams) => {
  const { featureConfigs } = useFeatureToggles();
  const { appointmentBookingVirtualAppointmentTypeId } = featureConfigs ?? {};
  const disabledSteps = React.useMemo(() => {
    const disabledSteps2 = Object.keys(mapStepToRoute).map((step) => Number(step)).filter((step) => step > active);
    const isVirtualAppointmentTypeId = queryParams.typeId === appointmentBookingVirtualAppointmentTypeId;
    if (isVirtualAppointmentTypeId && (active === steps.when || active === steps.who)) {
      disabledSteps2.push(steps.what);
    }
    return disabledSteps2;
  }, [active, queryParams, appointmentBookingVirtualAppointmentTypeId]);
  return disabledSteps;
};
export {
  useDisableSteps
};
//# sourceMappingURL=use-disabled-steps.js.map
